import { FC, useState } from 'react';

import { MainServiceApi } from '../../../../../../lib/api/mainServiceApi';

import { FlashbarProps } from '@awsui/components-react';
import { ICreateDuoType } from '../../../../../../interfaces/integrations/duo';

import View from './view';

interface IndexProps {
  refreshDuoTypeTable: () => void;
}

const CreateDuoTypeForm: FC<IndexProps> = ({ refreshDuoTypeTable }) => {
  const [flashBarItems, setFlashBarItems] = useState<
    FlashbarProps.MessageDefinition[]
  >([]);

  const formValues: ICreateDuoType = {
    typeName: ''
  };

  const handleSubmittedForm = async (data: ICreateDuoType) => {
    setFlashBarItems([
      {
        type: 'success',
        loading: true,
        content: 'Processing...'
      }
    ]);

    const api = new MainServiceApi();
    api
      .createDuoType(data)
      .then(() => {
        refreshDuoTypeTable();
        setFlashBarItems([
          {
            type: 'success',
            dismissible: true,
            dismissLabel: 'Dismiss message',
            onDismiss: () => setFlashBarItems([]),
            content: <>Duo Type has been created!</>
          }
        ]);
      })
      .catch(() => {
        setFlashBarItems([
          {
            type: 'error',
            dismissible: true,
            dismissLabel: 'Dismiss message',
            onDismiss: () => setFlashBarItems([]),
            content: <>Unable to create Duo Type!</>
          }
        ]);
      });
  };

  return (
    <View
      formValues={formValues}
      flashBarItems={flashBarItems}
      handleSubmittedForm={handleSubmittedForm}
    />
  );
};
export default CreateDuoTypeForm;
